import { useState } from "react";
import UsersMFAAPI from "../api/UsersMFAAPI";

const useSetUsersMFA = () => {
	const [saving, setSaving] = useState(false);

	/**
	 * @param {Map<number, boolean>} changes user id → desired enabled state
	 */
	const save = async (changes) => {
		setSaving(true);

		try {
			const payload = [...changes].map(([id, enabled]) => ({ id, action: enabled ? "enable" : "disable" }));
			const result = await UsersMFAAPI.updateMfaPreferences(payload);
			return { success: true, updated: result?.updated || [], failed: result?.failed || [] };
		} catch (err) {
			return { success: false, error: err.message };
		} finally {
			setSaving(false);
		}
	};

	return { save, saving };
};

export default useSetUsersMFA;
